export var TypographyTags;

(function (TypographyTags) {
  TypographyTags["DIV"] = "div";
  TypographyTags["SPAN"] = "span";
  TypographyTags["P"] = "p";
})(TypographyTags || (TypographyTags = {}));